module.exports = {
    blue: "blue",
    indigo: "indigo",
    purple: "purple",
    pink: "pink",
    mint: "mint",
    green: "green",
    brown: "brown",
    crimson: "crimson",
    red: "red",
    orange: "orange",
    yellow: "yellow",
    white: "white",
    smoke: "smoke",
    gray: "gray",
    slate: "slate",
  };